import React, { useState } from "react";
import SingleColor from "./SingleColor";

import Values from "values.js";

function App() {
  const [color, setColor] = useState("");
  const [error, setError] = useState(false);
  const [colorList, setColorList] = useState(new Values("#f15025").all(10));

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      let colors = new Values(color).all(10);
      setColorList(colors);
      setError(false);
    } catch (error) {
      setError(true);
      console.log(error.message);
    }
  };
  return (
    <>
      <section className="container">
        <h3>color generator</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="color"
            id="color"
            value={color}
            onChange={(e) => {
              setColor(e.target.value);
            }}
            // conditional class name addition!
            className={`${error ? "error" : null}`}
            placeholder="#f15025"
          />
          <button className="btn" type="submit">
            Generate
          </button>
        </form>
      </section>
      ;
      <section className="colors">
        {colorList.map((color, index) => {
          console.log(color);
          return (
            <SingleColor key={index} {...color} index={index}></SingleColor>
          );
        })}
      </section>
    </>
  );
}

export default App;
